export default "__VITE_ASSET__K4Dl_gbn__"